export default __webpack_public_path__ + "static/1LaPaperia-d77ecd945973188b72fb449bcdf0afd0.png";